var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteelhausHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 374.506 74.264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_10",
    "data-name": "New Gradient Swatch 10",
    cx: 19.1,
    cy: 9.795,
    fx: 19.1,
    fy: 9.795,
    r: 66.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#888a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_9",
    "data-name": "New Gradient Swatch 9",
    x1: 37.34,
    y1: 16.031,
    x2: 37.34,
    y2: 70.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_7",
    "data-name": "New Gradient Swatch 7",
    x1: 43.164,
    y1: 52.217,
    x2: 32.18,
    y2: 39.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#89c8dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e312f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_6",
    "data-name": "New Gradient Swatch 6",
    x1: 12.981,
    y1: 51.877,
    x2: 29.655,
    y2: 1.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#89c8dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e312f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_7-2",
    "data-name": "New Gradient Swatch 7",
    x1: 15.684,
    y1: 32.632,
    x2: 39.58,
    y2: 32.632,
    xlinkHref: "#New_Gradient_Swatch_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5",
    "data-name": "New Gradient Swatch 5",
    x1: 47.205,
    y1: 66.951,
    x2: 52.256,
    y2: 9.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#5c1516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9272b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_6-2",
    "data-name": "New Gradient Swatch 6",
    x1: 22.792,
    y1: 38.306,
    x2: 47.719,
    y2: -8.937,
    xlinkHref: "#New_Gradient_Swatch_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-2",
    "data-name": "New Gradient Swatch 5",
    x1: -778.803,
    y1: -609.8,
    x2: -762.087,
    y2: -660.72,
    gradientTransform: "translate(-716.871 -587.384) rotate(-180)",
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-3",
    "data-name": "New Gradient Swatch 5",
    x1: -775.966,
    y1: -629.253,
    x2: -752.071,
    y2: -629.253,
    gradientTransform: "translate(-716.871 -587.384) rotate(-180)",
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    "data-name": "New Gradient Swatch 4",
    x1: 45.892,
    y1: 16.634,
    x2: 47.597,
    y2: 37.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972e33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#c9272b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    "data-name": "New Gradient Swatch 4",
    x1: 43.63,
    y1: 10.862,
    x2: 70.548,
    y2: 49.526,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_1",
    "data-name": "New Gradient Swatch 1",
    cx: 24.259,
    cy: 37.168,
    fx: 24.259,
    fy: 37.168,
    r: 23.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#d0d0d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#808183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_1-2",
    "data-name": "New Gradient Swatch 1",
    cx: 90.397,
    cy: -539.109,
    fx: 90.397,
    fy: -539.109,
    r: 23.207,
    gradientTransform: "translate(140.69 -501.697) rotate(-180)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.721,41.297h17.041c.732,0,1.201-.08,1.406-.242.204-.161.307-.334.307-.519,0-.392-.205-.663-.615-.813-.41-.15-.864-.282-1.362-.398l-11.903-2.63c-.908-.184-1.64-.455-2.196-.813-.556-.357-.995-.697-1.318-1.021-.732-.762-1.193-1.626-1.384-2.595-.191-.969-.285-1.903-.285-2.803,0-.761.094-1.58.285-2.457.19-.876.739-1.672,1.648-2.388.497-.392,1.17-.744,2.02-1.055.849-.311,1.932-.467,3.25-.467h20.291v6.021h-15.635c-.586,0-.981.012-1.186.034-.205.023-.351.058-.439.104-.323.139-.483.358-.483.657,0,.393.285.681.857.865.571.185,1.149.334,1.735.45l10.365,2.18c.673.138,1.412.346,2.218.623.805.277,1.486.635,2.042,1.072.468.37.849.791,1.142,1.263.292.473.505.957.637,1.453.132.496.22.986.263,1.47.044.485.066.934.066,1.349,0,.715-.073,1.511-.22,2.388-.147.877-.571,1.684-1.274,2.422-.439.461-.908.819-1.405,1.072-.499.254-1.018.439-1.559.554-.542.116-1.084.185-1.625.208-.542.024-1.076.035-1.603.035h-21.081v-6.021Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.908,47.318v-18.2h-10.98v-6.021h31.886v6.021h-10.98v18.2h-9.926Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.709,47.318c-.644,0-1.281-.04-1.911-.121-.63-.081-1.237-.317-1.823-.71-.702-.461-1.113-.94-1.23-1.436-.117-.496-.176-1.032-.176-1.609v-16.608c0-.461.073-.934.22-1.419.146-.484.512-.934,1.098-1.349.585-.415,1.215-.68,1.889-.796.673-.115,1.288-.173,1.845-.173h22.092v5.882h-15.197c-.293,0-.578.029-.857.086-.279.058-.505.144-.68.26-.235.162-.373.358-.417.588-.044.231-.066.427-.066.588v1.834h16.778v5.259h-16.778v2.63c0,.254.044.45.132.588.088.138.19.242.308.311.234.185.527.283.878.294.351.012.687.017,1.01.017h15.021v5.882h-22.136Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.058,47.318c-.644,0-1.281-.04-1.911-.121-.63-.081-1.237-.317-1.822-.71-.702-.461-1.113-.94-1.23-1.436-.117-.496-.176-1.032-.176-1.609v-16.608c0-.461.073-.934.22-1.419.147-.484.512-.934,1.098-1.349.585-.415,1.215-.68,1.889-.796.673-.115,1.288-.173,1.845-.173h22.092v5.882h-15.197c-.293,0-.578.029-.857.086-.279.058-.504.144-.68.26-.235.162-.374.358-.417.588-.044.231-.066.427-.066.588v1.834h16.778v5.259h-16.778v2.63c0,.254.044.45.132.588.088.138.19.242.307.311.235.185.528.283.879.294.351.012.687.017,1.01.017h15.021v5.882h-22.136Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.968,47.318c-.587,0-1.186-.058-1.801-.173-.615-.115-1.128-.312-1.537-.588-.351-.23-.667-.554-.944-.969-.279-.415-.417-.876-.417-1.384v-21.107h9.926v16.712c0,.138.022.328.066.571.044.242.182.445.417.605.204.139.453.225.746.259.292.035.571.052.834.052h15.943v6.021h-23.233Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.526,47.318h-9.926v-9.619h-11.155v9.619h-9.926v-24.22h9.926v8.581h11.155v-8.581h9.926v24.22Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.78,25.762c.234-.438.512-.842.835-1.211.322-.369.746-.68,1.273-.934.528-.253,1.178-.45,1.955-.588.775-.139,1.763-.208,2.965-.208.731,0,1.442.03,2.13.087.688.058,1.332.185,1.933.381.6.196,1.157.49,1.669.882.512.393.944.923,1.296,1.592l11.376,21.556h-10.453l-2.415-4.983h-11.068l-2.415,4.983h-10.453l11.375-21.556ZM288.645,36.799h6.324l-2.767-6.124c-.059-.092-.125-.202-.198-.329-.073-.127-.139-.19-.197-.19-.059,0-.125.064-.198.19-.073.127-.139.237-.197.329l-2.767,6.124Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.014,23.097v13.91c0,.531.073,1.119.22,1.765.147.646.586,1.2,1.318,1.661.439.277,1.003.491,1.691.64.688.15,1.384.225,2.087.225s1.398-.075,2.086-.225c.688-.15,1.252-.363,1.691-.64.38-.23.673-.496.878-.796.204-.299.358-.605.461-.917.102-.311.16-.611.176-.9.014-.288.022-.559.022-.813v-13.91h9.926v14.532c0,.623-.038,1.246-.11,1.868-.073.623-.228,1.246-.461,1.869-.235.623-.564,1.228-.988,1.816-.425.588-.974,1.148-1.647,1.678-.79.623-1.655,1.113-2.591,1.47-.938.358-1.926.629-2.965.813-1.04.184-2.108.305-3.207.363-1.098.057-2.189.087-3.272.087-1.114,0-2.211-.03-3.294-.087-1.083-.058-2.145-.179-3.184-.363-1.039-.184-2.028-.455-2.965-.813-.937-.357-1.801-.848-2.591-1.47-.674-.53-1.223-1.09-1.647-1.678-.425-.588-.754-1.194-.988-1.816-.235-.623-.389-1.246-.461-1.869-.073-.623-.11-1.246-.11-1.868v-14.532h9.926Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.951,41.297h17.041c.732,0,1.201-.08,1.406-.242.204-.161.307-.334.307-.519,0-.392-.205-.663-.615-.813-.41-.15-.865-.282-1.362-.398l-11.902-2.63c-.908-.184-1.64-.455-2.196-.813-.556-.357-.995-.697-1.317-1.021-.733-.762-1.194-1.626-1.384-2.595-.191-.969-.285-1.903-.285-2.803,0-.761.094-1.58.285-2.457.19-.876.739-1.672,1.648-2.388.497-.392,1.17-.744,2.02-1.055.848-.311,1.933-.467,3.25-.467h20.291v6.021h-15.635c-.587,0-.982.012-1.186.034-.205.023-.351.058-.439.104-.323.139-.483.358-.483.657,0,.393.285.681.856.865.572.185,1.149.334,1.735.45l10.365,2.18c.673.138,1.412.346,2.218.623.805.277,1.486.635,2.042,1.072.468.37.849.791,1.142,1.263.292.473.504.957.636,1.453.132.496.22.986.264,1.47.044.485.065.934.065,1.349,0,.715-.073,1.511-.22,2.388-.147.877-.571,1.684-1.274,2.422-.439.461-.908.819-1.405,1.072-.498.254-1.018.439-1.56.554-.542.116-1.083.185-1.624.208-.543.024-1.076.035-1.604.035h-21.081v-6.021Z",
    style: {
      fill: "#040502"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M250.471,55.146h7.27v1.911h-2.439v5.829h-2.392v-5.829h-2.439v-1.911Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.819,55.146h6.409v1.653h-4.012v1.23h3.722v1.579h-3.722v1.526h4.128v1.753h-6.526v-7.74Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.785,59.718l2.096.633c-.141.588-.363,1.079-.665,1.473-.303.394-.678.692-1.127.892-.449.2-1.02.301-1.713.301-.841,0-1.528-.123-2.062-.367-.533-.244-.993-.675-1.381-1.29-.387-.615-.581-1.404-.581-2.364,0-1.28.34-2.264,1.022-2.952.681-.688,1.644-1.031,2.89-1.031.975,0,1.741.197,2.299.591.558.394.972,1,1.243,1.816l-2.112.47c-.074-.236-.151-.408-.232-.517-.134-.183-.297-.324-.491-.423-.194-.098-.41-.148-.649-.148-.542,0-.957.218-1.246.654-.218.324-.327.832-.327,1.524,0,.858.13,1.446.391,1.764.26.318.626.477,1.098.477.457,0,.803-.129,1.038-.386.234-.257.404-.63.509-1.119Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.054,55.146h2.392v2.708h2.613v-2.708h2.402v7.74h-2.402v-3.131h-2.613v3.131h-2.392v-7.74Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.066,55.146h2.233l2.915,4.282v-4.282h2.254v7.74h-2.254l-2.899-4.25v4.25h-2.249v-7.74Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.756,59.022c0-1.264.352-2.247,1.056-2.951.704-.704,1.684-1.056,2.941-1.056,1.288,0,2.281.346,2.978,1.037s1.045,1.66,1.045,2.906c0,.905-.152,1.646-.457,2.225-.305.579-.744,1.029-1.32,1.351-.576.322-1.293.483-2.152.483-.873,0-1.595-.139-2.167-.417-.572-.278-1.036-.718-1.391-1.32-.356-.602-.533-1.355-.533-2.26ZM295.148,59.032c0,.781.145,1.343.435,1.684.291.342.685.512,1.185.512.514,0,.912-.167,1.193-.501.282-.334.423-.935.423-1.8,0-.729-.147-1.261-.441-1.597-.294-.336-.692-.504-1.196-.504-.482,0-.87.171-1.161.512-.293.342-.438.906-.438,1.695Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.064,55.146h2.392v5.834h3.733v1.906h-6.124v-7.74Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.79,59.022c0-1.264.352-2.247,1.056-2.951.704-.704,1.684-1.056,2.941-1.056,1.288,0,2.281.346,2.978,1.037.697.692,1.045,1.66,1.045,2.906,0,.905-.152,1.646-.457,2.225-.305.579-.744,1.029-1.32,1.351-.576.322-1.293.483-2.152.483-.873,0-1.595-.139-2.167-.417-.572-.278-1.036-.718-1.391-1.32-.356-.602-.533-1.355-.533-2.26ZM311.182,59.032c0,.781.145,1.343.435,1.684.291.342.685.512,1.185.512.514,0,.912-.167,1.193-.501.282-.334.423-.935.423-1.8,0-.729-.147-1.261-.441-1.597-.294-.336-.692-.504-1.196-.504-.482,0-.87.171-1.161.512-.293.342-.438.906-.438,1.695Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.989,60.083v-1.61h3.696v3.3c-.707.482-1.333.81-1.877.985-.544.174-1.189.261-1.935.261-.918,0-1.667-.157-2.246-.47-.579-.313-1.028-.78-1.346-1.399-.319-.619-.478-1.331-.478-2.133,0-.845.174-1.58.523-2.204.348-.625.859-1.099,1.531-1.423.524-.25,1.23-.375,2.117-.375.855,0,1.495.077,1.919.232.424.155.776.395,1.056.72.28.326.49.738.631,1.238l-2.307.412c-.095-.292-.256-.516-.483-.671-.227-.155-.517-.232-.868-.232-.525,0-.943.182-1.254.546-.312.364-.467.941-.467,1.729,0,.837.158,1.436.473,1.795.315.359.754.538,1.317.538.268,0,.523-.039.766-.116.243-.077.521-.209.834-.396v-.728h-1.6Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.2,55.146h2.397v7.74h-2.397v-7.74Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.308,55.146h6.409v1.653h-4.012v1.23h3.722v1.579h-3.722v1.526h4.128v1.753h-6.526v-7.74Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.704,60.326l2.276-.142c.049.37.149.651.301.845.246.313.598.47,1.056.47.342,0,.605-.08.789-.24.185-.16.277-.346.277-.557,0-.2-.088-.38-.264-.538s-.584-.308-1.225-.449c-1.049-.236-1.797-.549-2.244-.94-.451-.391-.676-.889-.676-1.494,0-.398.115-.773.346-1.128.231-.354.577-.632,1.04-.834s1.097-.303,1.903-.303c.989,0,1.743.184,2.262.552.519.368.828.953.927,1.755l-2.255.132c-.06-.348-.186-.602-.377-.76-.192-.158-.457-.237-.795-.237-.278,0-.488.059-.628.177-.141.118-.212.261-.212.43,0,.123.058.234.174.333.113.102.38.197.803.285,1.045.225,1.794.453,2.246.684.452.231.781.516.987.858.206.341.309.723.309,1.145,0,.497-.137.954-.412,1.373-.275.419-.658.737-1.151.953-.493.217-1.114.325-1.863.325-1.317,0-2.228-.253-2.735-.76-.506-.507-.793-1.151-.861-1.933Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.631,55.146h2.397v7.74h-2.397v-7.74Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.76,55.146h2.233l2.915,4.282v-4.282h2.254v7.74h-2.254l-2.899-4.25v4.25h-2.249v-7.74Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.904,59.718l2.096.633c-.141.588-.363,1.079-.665,1.473-.303.394-.679.692-1.127.892-.449.2-1.02.301-1.713.301-.841,0-1.528-.123-2.062-.367-.533-.244-.993-.675-1.381-1.29-.387-.615-.581-1.404-.581-2.364,0-1.28.34-2.264,1.022-2.952.681-.688,1.644-1.031,2.89-1.031.975,0,1.741.197,2.299.591.558.394.972,1,1.243,1.816l-2.112.47c-.074-.236-.151-.408-.232-.517-.134-.183-.297-.324-.491-.423-.194-.098-.41-.148-.649-.148-.542,0-.957.218-1.246.654-.218.324-.327.832-.327,1.524,0,.858.13,1.446.391,1.764.26.318.626.477,1.098.477.457,0,.803-.129,1.038-.386.234-.257.404-.63.509-1.119Z",
    style: {
      fill: "#040502"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.209,60.732h2.297v2.154h-2.297v-2.154Z",
    style: {
      fill: "#040502"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.299,22.432s-3.779,9.762,3.332,19.135",
    style: {
      fill: "#272425"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.28,18.57C59.028.813,36.324-5.272,18.57,4.98.813,15.23-5.271,37.937,4.979,55.695c10.254,17.757,32.958,23.841,50.712,13.591,17.755-10.251,23.841-32.958,13.59-50.715Z",
    style: {
      fill: "url(#New_Gradient_Swatch_10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.598,21.132C56.588,5.525,36.632.176,21.026,9.187,5.42,18.196.071,38.154,9.083,53.762c9.009,15.608,28.966,20.955,44.571,11.947,15.606-9.013,20.955-28.969,11.944-44.577Z",
    style: {
      fill: "url(#New_Gradient_Swatch_9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23,37.162s-.334-26.626,27.731-28.286c0,0-11.284,15.773-1.019,28.231,0,0,10.709,14.336-5.538,28.536,0,0-20.239-2.951-21.173-28.48Z",
    style: {
      fill: "url(#New_Gradient_Swatch_7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.065,37.167s-2.602-22.085,19.895-28.291c0,0-25.471-.596-27.731,28.286l7.835.005Z",
    style: {
      fill: "url(#New_Gradient_Swatch_6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.241,8.285s-22.899,5.532-21.495,28.882c0,0,3.191,16.801,21.195,19.812,0,0,6.554-7.908-1.001-19.872,0,0-10.713-10.209,1.3-28.822Z",
    style: {
      fill: "url(#New_Gradient_Swatch_7-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.743,9.187s20.463,2.569,21.625,27.956c0,0,1.223,26.183-28.018,28.935,0,0,12.052-14.559,1.163-28.935,0,0-10.263-12.464,5.23-27.956Z",
    style: {
      fill: "url(#New_Gradient_Swatch_5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.746,37.167s-3.063-20.916,21.212-28.599c0,0-11.155,15.016-1.139,28.604l-20.073-.005Z",
    style: {
      fill: "url(#New_Gradient_Swatch_6-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.753,37.129s2.738,22.225-19.762,28.43c0,0,25.337.459,27.599-28.425l-7.837-.005Z",
    style: {
      fill: "url(#New_Gradient_Swatch_5-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.537,66.215s22.9-5.533,21.496-28.882c0,0-3.19-16.8-21.195-19.812,0,0-6.554,7.908,1,19.873,0,0,10.715,10.209-1.3,28.821Z",
    style: {
      fill: "url(#New_Gradient_Swatch_5-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.038,17.558s16.223,1.265,20.945,19.549h-21.008s-6.062-11.671.063-19.549Z",
    style: {
      fill: "url(#New_Gradient_Swatch_4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.984,37.107s-3.294-16.891-20.945-19.548c0,0,2.366-5.793,5.877-8.469,0,0,20.649,3.617,21.675,28.044l-6.606-.027Z",
    style: {
      fill: "url(#New_Gradient_Swatch_4-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.719,37.621c1.28-29.729,29.369-29.359,29.369-29.359-.805.62-11.864,14.434-1.944,28.641,10.635,15.232-5.309,29.171-5.309,29.171-22.662-5.383-22.116-28.453-22.116-28.453ZM30.413,65.024s15.535-13.371,4.953-27.859c-9.688-13.265.289-27.455,1.041-28.047,0,0-25.441.34-26.637,28.733,0,0-.509,22.031,20.643,27.173Z",
    style: {
      fill: "url(#New_Gradient_Swatch_1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.833,36.958c-1.282,29.73-29.369,29.361-29.369,29.361.805-.621,11.864-14.435,1.944-28.641-10.635-15.232,5.308-29.171,5.308-29.171,22.663,5.383,22.117,28.451,22.117,28.451ZM44.138,9.555s-15.534,13.373-4.953,27.86c9.688,13.264-.291,27.455-1.043,28.047,0,0,25.442-.339,26.639-28.734,0,0,.507-22.031-20.643-27.173Z",
    style: {
      fill: "url(#New_Gradient_Swatch_1-2)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteelhausHorizontal);
export default __webpack_public_path__ + "static/media/Steelhaus_Horizontal.8802b1d6a4ac9474dd6a9569b6df48e3.svg";
export { ForwardRef as ReactComponent };